export default __webpack_public_path__ + "static/media/EXTENROOF-MUMBAI.bd712b26.jpg";